module.exports = __webpack_public_path__ + "img/giantScreenLottery.12f96f7b.gif";